import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "malvaktslabb_token";

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear token so app can redirect to gate
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      // Only redirect if not already on gate/activate/share pages
      const p = window.location.pathname;
      if (!p.startsWith("/gate") && !p.startsWith("/share/")) {
        window.location.href = "/gate";
      }
    }
    return Promise.reject(err);
  }
);

export const ZONES = ["V1", "V2", "V3", "H3", "H2", "H1"];
export const DISTANCES = [
  { value: "9m", label: "9M" },
  { value: "mellan", label: "MELLAN" },
  { value: "6m", label: "6M" },
  { value: "7m", label: "7M STRAFF" },
];

export function pctToColor(pct, total) {
  if (!total) return { bg: "#1A1A1A", fg: "#52525B" };
  const clamp = Math.max(0, Math.min(100, pct));
  let r, g, b;
  if (clamp < 50) {
    const t = clamp / 50;
    r = 255;
    g = Math.round(59 + (214 - 59) * t);
    b = Math.round(48 + (10 - 48) * t);
  } else {
    const t = (clamp - 50) / 50;
    r = Math.round(255 + (52 - 255) * t);
    g = Math.round(214 + (199 - 214) * t);
    b = Math.round(10 + (89 - 10) * t);
  }
  return { bg: `rgb(${r}, ${g}, ${b})`, fg: "#0a0a0a" };
}
